<template>
  <div>
    <base-card>
      <v-card-text>
        <div class="d-flex flex-column align-center justify-center text-center py-3">
          <h2 class="mb-5">Información Exógena</h2>
        </div>
      </v-card-text>
    </base-card>  
    <v-row justify="center" style="margin-left: 1% !important" class="mt-3">
      <v-layout class="overflow-visible" style="height: 56px">
        <v-bottom-navigation
          :elevation="24"
          v-model="selectedTab"
          color="rgb(204 33 40)"
          width="98% !important"
        >
          <v-btn value="configImport" class="nav-btn">
            Configuración - Importación
          </v-btn>

          <v-btn value="configFormats" class="nav-btn">
            Configuración - Formatos
          </v-btn>

          <v-btn value="generationFormats" class="nav-btn">
            Generación de formatos
          </v-btn>
        </v-bottom-navigation>
      </v-layout>
    </v-row>

    <base-card>
      <v-card-text class="mt-3">
        <div>
          <component
            :is="currentComponent"
            v-bind="componentProps"
          />
        </div>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
import GenerationFormatsExogena from "@/views/app/taxreports/components/GenerationFormatsExogena.vue";
import DataImportExogena from "@/views/app/taxreports/components/DataImportExogena.vue";
import ConfigFormatsExogena from "@/views/app/taxreports/components/ConfigFormatsExogena.vue";


export default {
  data() {
    return {
      selectedTab: "configImport",
    };
  },
  computed: {
    currentComponent() {
      switch (this.selectedTab) {
        case "generationFormats":
          return GenerationFormatsExogena;
        case "configImport":
          return DataImportExogena;
        case "configFormats":
          return ConfigFormatsExogena;
        default:
          return GenerationFormatsExogena;
      }
    },
    componentProps() {
      if (this.selectedTab === "configImport") {
        return {
          selectComponent: 'EXOGENA',
        };
      }

      return {};
    },
  },
};
</script>
<style scoped>
.nav-btn {
  white-space: normal !important;
  line-height: 1.2;
  height: auto !important;
  min-width: 120px;
  text-align: center;
  max-width: -webkit-fill-available !important;
  font-size: unset !important;
}

</style>
